export const GET_REDEEM = "GET_REDEEM";
export const GET_SETTING = "GET_SETTING";

